<template>
  <li :class="{winner: isWinner, loser: isLoser}">
    <div class="left">
      <slot name="left" class="left" />
    </div>
    <div class="right">
      <slot name="right" class="right" />
    </div>
  </li>
</template>

<script>
  export default {
    name: 'OriginListItem',
    props: {
      isWinner: Boolean,
      isLoser: Boolean
    }
  }
</script>

<style lang="less" scoped>
  li {
    display: flex;
    line-height: 2.5;
    font-weight: bold;
    color: #424848;
    border-bottom: 1px solid #cdd7d7;
    padding: 0.5rem 0rem;
  }
  li:first-child {
    color: #06a386;
  }
  .left {
    display: inline-block;
    padding-left: 2rem;
    left: 0;
  }
  .right {
    display: inline-block;
    padding-right: 2rem;
    margin-left: auto;
  }
  .winner {
    background: #00a486;
    color: white;
  }
  .loser {
    background: #e84100;
    color: #ffffff;
  }
</style>
